export const SERVICE_ID = "service_26g54ba";
export const TEMPLATE_ID = "template_r4c729s";
export const PUBLIC_KEY = "M2ln7H48eVU-9LpeQ";
export const GITHUB_LINK = "https://github.com/shruti284";
export const LINKEDIN_LINK = "https://www.linkedin.com/in/shrutianantwar/";